import {PixelRatio, View, ScrollView} from 'react-native';
import DashedLine from 'react-native-dashed-line';
import Util from 'src/Util';
import Styles from '../../../Styles';
import AVFormattedCurrency from '../../AVFormattedCurrency';
import type {HistoryItem} from 'src/types/TransactionDetail';
import AVText from '../../AVText';
import {WithLocalizedProps} from 'src/types/PropTypes';
import AccountStore from 'src/stores/AccountStore';
import {getDescriber as getSnackDescriber} from 'src/components/screens/sendSnack/descriptor/sendasnack/DescriptorType';
import {getDescriber} from 'src/components/elements/account/descriptor/DescriptorType';
import {getDescriber as componentDescriber} from './descriptor/DescriptorType';

type RedemptionDetailProps = WithLocalizedProps & {
  detail: HistoryItem;
};

const styles = componentDescriber().redemptionDetailStyle();

const RedemptionDetail = (props: RedemptionDetailProps) => {
  return (
    <View style={styles.container}>
      <ScrollView style={styles.content}>
        <AVText
          accessible={true}
          accessibilityLabel={`${
            props.strings.Labels.transaction_date
          } $${Util.formatDate(props.detail.TransDate, 'LLL')}`}
          aria-label={`${
            props.strings.Labels.transaction_date
          } $${Util.formatDate(props.detail.TransDate, 'LLL')}`}
          style={[styles.date, getSnackDescriber()?.snackDetailsBtnFontSTyle()]}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm9}
        >
          {Util.formatDate(props.detail.TransDate, 'LLL')}
        </AVText>
        <AVText
          accessible={true}
          accessibilityLabel={`${
            props.strings.Labels.location
          } $${Util.formatDate(props.detail.TransDate, 'LLL')}`}
          aria-label={`${props.strings.Labels.location} $${Util.formatDate(
            props.detail.TransDate,
            'LLL',
          )}`}
          style={[
            styles.location,
            getSnackDescriber()?.snackDetailsBtnFontSTyle(),
          ]}
        >
          {props.detail.Location}
        </AVText>
        <AVText
          accessible={true}
          accessibilityLabel={props.strings.Labels.transaction_id}
          aria-label={props.strings.Labels.transaction_id}
          style={[
            styles.trans,
            getSnackDescriber()?.snackDetailsBtnFontSTyle(),
          ]}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm9}
        >
          {props.detail.Id}
        </AVText>
        <DashedLine
          dashGap={PixelRatio.roundToNearestPixel(4)}
          dashLength={PixelRatio.roundToNearestPixel(2)}
          dashThickness={1}
          dashColor="#999"
          style={styles.dashStyle}
        />

        <View accessible={true} style={[styles.row]}>
          <AVText
            accessibilityLabel={props.strings.Labels.loyalty_credit}
            aria-label={props.strings.Labels.loyalty_credit}
            style={[
              styles.largeLabel,
              styles.textLabel,
              getSnackDescriber()?.snackDetailsBtnFontSTyle(),
            ]}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
          >
            {props.strings.Labels.loyalty_credit}
          </AVText>
          <AVFormattedCurrency
            style={[
              styles.largeLabel,
              getSnackDescriber()?.snackDetailsBtnFontSTyle(),
            ]}
            value={props.detail.Amount}
            accessibilityLabel={`$${props.detail.Amount}`}
            aria-label={`$${props.detail.Amount}`}
            currency={props.detail.currency ?? AccountStore.getCurrency()}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
          />
        </View>

        <DashedLine
          dashGap={PixelRatio.roundToNearestPixel(4)}
          dashLength={PixelRatio.roundToNearestPixel(2)}
          dashThickness={1}
          dashColor="#999"
          style={styles.dashStyle}
        />

        <View
          accessible={true}
          style={[getDescriber().redemptionDetailContainer()]}
        >
          <View
            style={[Styles.Style.labelColumn, getDescriber().leftViewStyle()]}
          >
            <AVText
              accessibilityLabel={props.strings.Labels.total}
              aria-label={props.strings.Labels.total}
              style={[
                styles.total,
                getSnackDescriber()?.snackDetailsBtnFontSTyle(),
              ]}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm6}
            >
              {props.strings.Labels.total}
            </AVText>
          </View>
          <View style={Styles.Style.amountColumn}>
            <AVFormattedCurrency
              style={[
                styles.total,
                getSnackDescriber()?.snackDetailsBtnFontSTyle(),
              ]}
              value={props.detail.Amount}
              accessibilityLabel={`$${props.detail.Amount}`}
              aria-label={`$${props.detail.Amount}`}
              currency={props.detail.currency ?? AccountStore.getCurrency()}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm6}
            />
          </View>
        </View>
      </ScrollView>
    </View>
  );
};

export default RedemptionDetail;
